import React  from 'react'
import { View, StyleSheet } from 'react-native'
import { Icon, Text, Button, useTheme } from '@ui-kitten/components'
import { FontAwesome5 } from '@expo/vector-icons'
import { currencyFormatterAtom, storesDictAtom, userRoleAtom, usersDictAtom } from '../../global/AtomsProvider'
import { useAtomValue } from 'jotai'
import OperationsList from '../../components/OperationsList'
import { useTranslation } from 'react-i18next'

/**
 * Find a user by any ID format (Supabase UUID or Firestore ID)
 */
const findUserByAnyId = (usersDict, ...ids) => {
  for (const id of ids) {
    if (id && usersDict[id]) return usersDict[id]
  }
  const userIds = ids.filter(id => id)
  if (userIds.length > 0) {
    for (const user of Object.values(usersDict)) {
      if (userIds.includes(user.id) || userIds.includes(user.firestoreId)) return user
    }
  }
  return null
}

/**
 * Find a store by any ID format (Supabase UUID or Firestore ID)
 */
const findStoreByAnyId = (storesDict, ...ids) => {
  for (const id of ids) {
    if (id && storesDict[id]) return storesDict[id]
  }
  const storeIds = ids.filter(id => id)
  if (storeIds.length > 0) {
    for (const store of Object.values(storesDict)) {
      if (storeIds.includes(store.id) || storeIds.includes(store.firestoreId)) return store
    }
  }
  return null
}

export default function WriteOffsScreen({ navigation }) {
  const { t } = useTranslation()
  const theme = useTheme()
  const usersDict = useAtomValue(usersDictAtom)
  const currencyFormatter = useAtomValue(currencyFormatterAtom)
  const storesDict = useAtomValue(storesDictAtom)
  const userRole = useAtomValue(userRoleAtom)

  const renderItemFieldsToShow = (item, date) => {
    return (
      <>
        <View style={styles.dateTimeView}>
          <Icon name='pricetags-outline' width={16} height={16} fill={theme['text-basic-color']} style={styles.icon} />
          <Text
            style={styles.itemTitle}
            category='s2'>
            {item.product.name}
          </Text>
        </View>

        <View style={styles.dateTimeView}>
          <Icon name='bar-chart-outline' width={16} height={16} fill={theme['text-basic-color']} style={styles.icon} />
          <Text
            style={styles.itemTitle}
            category='s2'>
            {item.quantity}
          </Text>
        </View>

        <View style={styles.dateTimeView}>
          <Icon name='credit-card-outline' width={16} height={16} fill={theme['text-basic-color']} style={styles.icon} />
          <Text
            style={styles.itemTitle}
            category='s2'>
            {currencyFormatter.format(item.totalSum)}
          </Text>
        </View>
        
        <View style={styles.dateTimeView}>
          <Icon name='clock-outline' width={16} height={16} fill={theme['text-basic-color']} style={styles.icon} />
          <Text
            style={styles.itemTitle}
            category='s2'>
            {date}
          </Text>
        </View>

        <View style={styles.dateTimeView}>
          <Icon name='person-outline' width={16} height={16} fill={theme['text-basic-color']} style={styles.icon} />
          <Text
            style={styles.itemTitle}
            category='s2'>
            {findUserByAnyId(usersDict, item.cashierUID, item.cashier_id, item.cashierId)?.name}
          </Text>
        </View>

        <View style={styles.dateTimeView}>
          <FontAwesome5 name="building" size={16} color={theme['text-basic-color']} style={styles.icon} />
          <Text
            style={styles.itemTitle}
            category='s2'>
            {findStoreByAnyId(storesDict, item.store, item.store_id, item.storeId)?.name}
          </Text>
        </View>
      </>
    )
  }

  const topView = () => {
    if (userRole?.permissions?.['Stats'] || userRole?.id === 'admin') {
      return (
        <Button style={{alignSelf: 'flex-end'}} appearance='ghost' size='small' onPress={() => {
          navigation.navigate('ProductStats', {initialColumns: {writeOffAmount: true, writeOffQuantity: true}})}}
          accessoryLeft={(props) => (<Icon name='bar-chart-outline' {...props} style={{...props.style, marginRight: 0}} />)}
        >
          {t('writeOffs.writeOffStats')}
        </Button>
      )
    } else {
      return null
    }
  }

  return (
    <View style={styles.container}>
      <OperationsList collectionName='writeOffs' renderItemFieldsToShow={renderItemFieldsToShow} 
        navigation={navigation} dateField={'date'} additionalFilters={null} showStoreFilter={true}
        detailScreenName={'WriteOffDetail'} topView={topView} initialRange={null}
        showTotalSum={false} totalSumFormatter={currencyFormatter} totalSumField={'totalSum'}
        showAddButton={true} additionalDataValidation={() => {}} detailScreenParams={{}}
      />
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  icon: {
    marginRight: 4,
  },
  itemTitle: {
    marginRight: 25,
  },
  dateTimeView: {
    flexDirection: 'row',
    alignItems: 'center'
  },
});
